/**
 * ヘッダーコンポーネント
 *
 * ロゴとナビゲーションメニューを表示。
 * 契約完了ユーザーにのみメニューを表示する。
 */
import { PositionNumber } from 'api/common/constants'
import IconArrow from 'images/icon_arrow.svg'
import iconClose from 'images/icon_close.svg'
import iconMenu from 'images/icon_menu.svg'
import logo2 from 'images/logo2.png'
import * as React from 'react'
import { ListGroup, Navbar, Offcanvas } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'

interface Props {
  title: string
}

const Component: React.FC<Props> = ({ title }) => {
  const navigate = useNavigate()
  const [show, setShow] = React.useState(false)

  // メニュー表示制御
  // loginDataはシングルトンのため、初期レンダリング時に値が古い可能性がある
  // useStateとuseEffectで最新状態を反映させる
  const [canShowMenu, setCanShowMenu] = React.useState(loginData.canUseNavMenu())

  React.useEffect(() => {
    setCanShowMenu(loginData.canUseNavMenu())
  }, [])
  const menuItems = [
    {
      label: 'マイページ',
      path: '/myPage',
    },
    {
      label: 'お知らせ',
      path: '/notificationList',
    },
    {
      label: '組織管理',
      path: '/organizationManagement',
    },
    {
      label: '昇格条件・維持条件',
      path: '/conditionCheck',
    },
    {
      label: 'コネクター登録・ポジション管理',
      path: '/positionManagement',
    },
    {
      label: '出金申請',
      path: '/showWithdrawal',
    },
    {
      label: '決済履歴',
      path: '/settlementList',
    },
    {
      label: '報酬明細',
      path: '/rewardSlip',
    },
    {
      label: '紹介者管理',
      path: `/referrerManagementBinaryMap/${PositionNumber.MainPosition}/0`,
    },
    {
      label: '書類管理',
      path: '/documentDownload',
    },
    {
      label: 'お問い合わせ',
      path: '/contactUs',
    },
    {
      label: 'ログアウト',
      clickEvent: () => {
        loginData.clear()
        navigate('/')
      },
    },
  ]
  return (
    <>
      <Navbar expand={false} className="px-3">
        <Navbar.Brand>
          <img src={logo2} alt="Logo" className="header-logo" />
        </Navbar.Brand>
        {canShowMenu && (
          <>
            <button className="border-0 bg-transparent" onClick={() => setShow(true)}>
              <img src={iconMenu} alt="Menu Icon" className="header-menu-icon" />
              <div style={{ fontSize: '12px' }}>メニュー</div>
            </button>
            <Navbar.Offcanvas className="h-fit" placement="top" show={show} onHide={() => setShow(false)}>
              <Offcanvas.Header className="header-logo-container position-relative">
                <Offcanvas.Title className="w-100 text-center">メニュー</Offcanvas.Title>
                <div className="position-absolute end-0">
                  <button className="d-flex flex-column me-1 border-0 bg-transparent" onClick={() => setShow(false)}>
                    <img src={iconClose} alt="Close Icon" className="header-menu-icon" />
                    <div className="w-100 text-center" style={{ fontSize: '12px' }}>
                      とじる
                    </div>
                  </button>
                </div>
              </Offcanvas.Header>
              <Offcanvas.Body className="p-0">
                <ListGroup variant="flush">
                  {menuItems.map(({ label, path, clickEvent }, index) => (
                    <ListGroup.Item className="d-flex justify-content-between align-items-center px-4 py-3" action href={path} onClick={clickEvent} key={index}>
                      <div>{label}</div>
                      <div>
                        <img src={IconArrow} alt="arrow" />
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </>
        )}
      </Navbar>
      <hr className="m-0" />
      <h1 style={{ margin: '40px 0' }}>{title}</h1>
    </>
  )
}
export default Component
